export const productHeaders = [
  "productName",
  "tradeName",
  "category",
  "subCategory",
  "ingredient",
  "nature",
  "code",
  "brand",
  "measurementUnit",
  "subMeasurementUnit",
  "formula",
  "batchNumber",
  "manufacturingDate",
  "expiryDate",
  "location",
  "unitSellingPrice",
  "subUnitSellingPrice",
  "administeringCharges",
  "taxApplicability",
  "tax",
  "dosageRecommendations",
  "composition",
  "sideEffects",
  "instructions",
  "description",
];

export const serviceHeaders = [
  "serviceName",
  "category",
  "subCategory",
  "sellingPrice",
  "taxApplicability",
  "tax",
  "description",
];

export const petsHeaders = [
  "name",
  "parentName",
  "species",
  "breed",
  "color",
  "gender",
  "petAge",
  "reproductiveStatus",
  "weight",
  "rfid",
];

export const appointmentHeaders = [
  "apntDateAndTime",
  "apntPetName",
  "parentName",
  "vetName",
  "consultationType",
  "category",
  "serviceType",
];

export const paymentsHeaders = [
  "trDate",
  "payPetName",
  "vetName",
  "balanceDue",
  "consultationType",
  "paymentStatus",
];

export const stockSummaryHeaders = [
  "product",
  "category",
  "hsnSacCode",
  "batch",
  "mfgDate",
  "expiryDate",
  "quantity",
  "location",
];

export const stockAdjustHeaders = [
  "date",
  "by",
  "type",
  "customer",
  "supplier",
  "invoiceNo",
  "product",
  "batchNo",
  "quantity",
  "remarks",
];

export const stockSupplierHeaders = [
  "supplierName",
  "gst",
  "billDate",
  "invoiceNumber",
  "totalTaxableValue",
  "totalTaxAmount",
  "totalAdditionalCharges",
  "grandTotal",
];

export const stockConsumptionHeaders = [
  "date",
  "vetName",
  "customer",
  "type",
  "product",
  "batchNo",
  "quantity",
];

export const nameExpan = {
  productName: "Product Name",
  tradeName: "Trade Name",
  category: "Category",
  subCategory: "Subcategory",
  tax: "Tax(%)",
  unitSellingPrice: "Unit Selling Price",
  subUnitSellingPrice: "Subunit Selling Price",

  serviceName: "Service Name",
  sellingPrice: "Selling Price",

  name: "Name",
  parentName: "Parent Name",
  breed: "Breed",
  gender: "Gender",
  reproductiveStatus: "Reproductive Status",
  species: "Species",
  petAge: "Age",
  color: "Color",
  weight: "Weight",
  rfid: "Microchip Number",

  apntPetName: "Pet Name",
  apntDateAndTime: "Appointment Date/Time",
  serviceType: "Service Type",

  payPetName: "Pet Name",
  vetName: "Vet Name",
  balanceDue: "Balance Due",
  consultationType: "Consultation Type",
  paymentStatus: "Payment Status",
  trDate: "Tr. Date",

  supplierName: "Supplier Name",
  quantity: "Quantity",
  price: "Price",
  batchNo: "Batch No",

  ingredient: "Major Active Ingredients",

  taxApplicability: "Tax applicability",
  description: "Description",
  nature: "Nature",
  code: "Barcode Number",
  brand: "Brand",
  measurementUnit: "Measurement Unit",
  subMeasurementUnit: "Sub-Measurement Unit",
  formula: "Formula",
  batchNumber: "Batch Number",
  manufacturingDate: "Mfg Date",
  expiryDate: "Expiry Date",
  location: "Location",
  administeringCharges: "Administering Charges",
  dosageRecommendations: "Dosage Recommendations",
  composition: "Composition",
  sideEffects: "Side Effects",
  instructions: "Instructions",

  product: "Product",
  batch: "Batch",
  mfgDate: "Mfg. Date",

  hsnSacCode: "HSN/SAC Code",
  hsnCode: "HSN Code",
  sacCode: "SAC Code",

  date: "Date",
  by: "By",
  type: "Type",
  customer: "Customer",
  supplier: "Supplier",
  invoiceNo: "Invoice No",
  remarks: "Remarks",

  gst: "GST",
  billDate: "Bill Date",
  invoiceNumber: "Invoice Number",
  totalTaxableValue: "Total Taxable Value",
  totalTaxAmount: "Total Tax Amount",
  totalAdditionalCharges: "Total Additional Charges",
  grandTotal: "Grand Total",

  petId: "Pet Id",
  petName: "Pet Name",
  petType: "Pet Type",
  lastVisitDate: "Last Visit Date",
  visitStatus: "Visit Status",

  appointmentId: "Appointment Id",
  caseId: "Case ID",
  visitType: "Visit Type",
  status: "Status",
  appointmentDetails: "Appointment Details",
  system: "System",
  condition: "Condition",

  consultAppointmentId: "Appointment Id",
  revenue: "Revenue",
  timeSpent: "Time Spent",
  delay: "Delay",
  delayMinutes: "Delay Minutes",
  delayStatus: "Delay Status",
  waitTime: "Wait Time",
  rating: "Rating",
  // typeOfConsult: "Type Of Consult",
  modeOfBooking: "Booking Type",
  scheduledOrImmediate: "Scheduled/Immediate",
  rescheduled: "Rescheduled",

  speciality: "Speciality",

  vetId: "Vet Id",
  // slotsAvailable: "SlotsAvailable",
  slotsBooked: "Slots Booked",
  slotsRemaining: "Slots Remaining",
  utilizationPercentage: "Utilization Percentage",

  timeDelayed: "Time Delayed",
  timeDelayedMinutes: "Time Delayed Minutes",

  appointmentDate: "Appointment Date",
  appointmentType: "Appointment Type",

  timeSpentMinutes: "Time Spent Minutes",
  waitTimeMinutes: "Wait Time Minutes",

  facilityType: "Facility Type",
  facilityName: "Facility Name",
  primaryStorage: "Primary Storage",
  secondaryStorage: "Secondary Storage",
  createdBy: "Created By",
  totalAppointments: "No. of Appointments",

  orderId: "Order Id",
  treatmentInvoiceNumber: "Treatment Invoice Number",
  petShopInvoiceNumber: "Pet Shop Invoice Number",
  receipt: "Receipt",
  createdDate: "Created Date",
  totalAmt: "Total",
  taxAmt: "Tax",
  amtPaid: "Amount Paid",
  paymentMode: "Payment Mode",
  userName: "User Name",
  email: "Email",
  mobile: "Mobile",
  doctorName: "Doctor Name",
  discount: "Discount",
  usedDiscountIds: "Used Discount Ids",
  appointmentStatus: "Appointment Status",
  inpatient: "Inpatient",
  appointmentdateTime: "Appointment Date",

  paymentOption: "Payment Option",

  barcodeNo: "Barcode Number",
  reorderLevel: "Reorder Level",
  quantityAsOnToday: "Qty As On Today",
  averagePurchasePrice: "Avg. Purchase Price",
  averageSellingPrice: "Avg. Selling Price",
  grossMargin: "Gross Margin",
  grossMarginAmount: "Gross Margin Amount",
  grossMarginPercentage: "Gross Margin Percentage",
  movementType: "Movement Type",
  averageDailySales: "Avg. Daily Sales",
  unitsSold: "Units Sold",
  unitsPurchased: "Units Purchased",

  updatedQuantity: "Updated Quantity",
  daysUntilExpiry: "Days Until Expiry",
  isExpired: "Expired",
  landedCost: "Landed Cost",

  timesUsed: "No. of Times Used",
  averageTimeSpentMinutes: "Avg Time Spent In Minutes",
  billedAmount: "Bill Amount",
  paymentDate: "Payment Date",

  invoice: "Invoice",
  refundableTax: "Refundable Tax",
  returnTotal: "Return Total",

  typeOfConsult: "Consultation Mode",
  cancellationReason: "Cancellation Reason",
  rescheduledReason: "Rescheduling Reason",
  appointmentDateTime: "Appointment Date & Time",

  slotsAvailable: "Total No. of Slots",
  overtimetime: "Overtime",

  ownershipType: "Ownership Type",
  petStatus: "Pet Status",
  bloodGroup: "Blood Group",
  temperament: "Temperament",

  conditionStatus: "Condition Status",
  bookingSource: "Booking Source",
  averageDowntime: "Average Downtime",
  utilizationTime: "Utilization Time",

  returnDate: "Return Date",
  customerUserName: "Customer Name",
  taxRefund: "Tax Refund",
  totalRefund: "Total Refund",

  invoiceDate: "Invoice Date",
  totalDue: "Total Due",
  discountCode: "Discount Code",
  taxes: "Taxes",
  collectionDate: "Collection Date",

  qty: "QTY",
  subunits: "Subunit Qty",

  totalRevenue: "Total Revenue",
  totalDiscount: "Total Discount",
  averageTimeSpent: "Avg. Time Spent",
  variantName: "Variant Name",
  variantNumber: "Variant ID",
  subcategory: "Subcategory",

  appointmentDateAndTime: "Appt Date & Time",
  facility: "Facility",
  reason: "Reason",
  assignedUsers: "Assigned Users",
  extraStatus: "",
};
